module.exports = __webpack_public_path__ + "static/media/6042.d4dd2323.jpg";